import { ThemeProvider } from "@mui/material/styles";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";
import BackToTopButton from "./components/BackToTopButton";
import Footer from "./components/FooterBite";
import { LoaderProvider } from "./components/LoaderContext";
import Navbar from "./components/Navbar";
import PageLoader from "./components/PageLoader";
import ScrollToTop from "./components/ScrollToTop";
import useAnalyticsTracker from "./hooks/useAnalyticsTracker";
import AboutPage from "./pages/AboutUs/AboutPage";
import CareersPage from "./pages/Careers/CareersPage";
import Contact from "./pages/Contact";
import FAQPage from "./pages/FAQs";
import GetQuotePage from "./pages/GetQuotePage";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ProductsPage from "./pages/Products/ProductsPage";
import ServicesPage from "./pages/Services/ServicesPage";
import TermsAndConditionsPage from "./pages/TermsAndConditions";
import theme from "./theme";
import LinkButtonFloting from "./components/LinkButtonFloting";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

function Layout({ children }) {
  const location = useLocation();
  // 💡 CALL THE ANALYTICS HOOK HERE
  useAnalyticsTracker();
  // Pages where Navbar/Footer should be hidden
  const hideLayout = location.pathname === "/signIn";

  return (
    <>
      {!hideLayout && <Navbar />}
      {children}
      <LinkButtonFloting />
      <BackToTopButton />
      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LoaderProvider>
        <PageLoader />
        <Router>
          <ScrollToTop />

          <Routes>
            <Route
              path="/"
              element={
                <Layout>
                  <Home />
                </Layout>
              }
            />

            <Route
              path="/about-us"
              element={
                <Layout>
                  <AboutPage />
                </Layout>
              }
            />

            <Route
              path="/contact-us"
              element={
                <Layout>
                  <Contact />
                </Layout>
              }
            />

            <Route
              path="/products"
              element={
                <Layout>
                  <ProductsPage />
                </Layout>
              }
            />

            {/* <Route
              path="/products/:id"
              element={
                <Layout>
                  <ProductCategoryPage />
                </Layout>
              }
            /> */}

            {/* <Route
              path="/projects"
              element={
                <Layout>
                  <ProjectsPage />
                </Layout>
              }
            />

            <Route
              path="/projects/:id"
              element={
                <Layout>
                  <ProjectDetailsPage />
                </Layout>
              }
            /> */}

            {/* <Route
              path="/blogs"
              element={
                <Layout>
                  <BlogPage />
                </Layout>
              }
            />

            <Route
              path="/blogs/:id"
              element={
                <Layout>
                  <BlogDetailsPage />
                </Layout>
              }
            /> */}

            <Route
              path="/services"
              element={
                <Layout>
                  <ServicesPage />
                </Layout>
              }
            />

            {/* <Route
              path="/services/:id"
              element={
                <Layout>
                  <ServiceCategoryPage />
                </Layout>
              }
            /> */}

            <Route
              path="/terms-and-conditions"
              element={
                <Layout>
                  <TermsAndConditionsPage />
                </Layout>
              }
            />

            <Route
              path="/privacy-policy"
              element={
                <Layout>
                  <PrivacyPolicyPage />
                </Layout>
              }
            />

            {/* <Route
              path="/certifications"
              element={
                <Layout>
                  <CertificationsPage />
                </Layout>
              }
            /> */}

            <Route
              path="/get-quote"
              element={
                <Layout>
                  <GetQuotePage />
                </Layout>
              }
            />

            <Route
              path="/careers"
              element={
                <Layout>
                  <CareersPage />
                </Layout>
              }
            />

            {/* <Route
              path="/gallery"
              element={
                <Layout>
                  <GalleryPage />
                </Layout>
              }
            /> */}

            <Route
              path="/faqs"
              element={
                <Layout>
                  <FAQPage />
                </Layout>
              }
            />
            <Route path="*" element={<NotFound />} />

            {/* <Route path="/superadmin/login" element={<AdminLogin />} /> */}

            {/* <Route
              element={
                <AdminProtectedRoute>
                  <AdminLayout />
                </AdminProtectedRoute>
              }
            >
              <Route
                path="/superadmin/dashboard"
                element={<AdminDashboard />}
              />
              <Route path="/superadmin/gallery" element={<AdminGallery />} />
            </Route> */}
          </Routes>
          {/* Toast Notifications */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Router>
      </LoaderProvider>
    </ThemeProvider>
  );
}

export default App;
